import React, { useEffect } from 'react';

import { LuxuryHomesHero } from './hero';
import { LuxuryHomesProperties } from './properties/component';

import { LuxuryHomesMain } from '../commons/main/component';

import { Routes } from '@share/constants';

import './style.scss';

export const LuxuryHomesPlace: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LuxuryHomesMain route={Routes.LuxuryHomes} childrenHero={<LuxuryHomesHero />}>                  
      <LuxuryHomesProperties />
    </LuxuryHomesMain>
  );
};
